import { render, staticRenderFns } from "./painel-coupon-list.vue?vue&type=template&id=696ee330&"
import script from "./painel-coupon-list.vue?vue&type=script&lang=js&"
export * from "./painel-coupon-list.vue?vue&type=script&lang=js&"
import style0 from "./painel-coupon-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports